export enum FilterTypes {
  ALL = 'ALL',
  UPDATES = 'UPDATES',
  SUBMITTED = 'SUBMITTED',
}
